import {
  boxApply1qmzdb3dh90hg as boxApply,
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../js/coreRuntime.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { Companion_instance2ztfx9zvq7j5d as Companion_instance } from './AbstractList.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
import { AbstractMutableCollections0bg6c40ztuj as AbstractMutableCollection } from './AbstractMutableCollectionJs.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtMutableList1beimitadwkna as KtMutableList,
} from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var IteratorImplClass;
function IteratorImpl() {
  if (IteratorImplClass === VOID) {
    class $ {
      constructor($outer, $box) {
        boxApply(this, $box);
        this.t6_1 = $outer;
        this.r6_1 = 0;
        this.s6_1 = -1;
      }
      q1() {
        return this.r6_1 < this.t6_1.q2();
      }
      r1() {
        if (!this.q1())
          throw NoSuchElementException().u6();
        var tmp = this;
        var _unary__edvuaz = this.r6_1;
        this.r6_1 = _unary__edvuaz + 1 | 0;
        tmp.s6_1 = _unary__edvuaz;
        return this.t6_1.r2(this.s6_1);
      }
      q6() {
        // Inline function 'kotlin.check' call
        if (!!(this.s6_1 === -1)) {
          var message = 'Call next() or previous() before removing element from the iterator.';
          throw IllegalStateException().o(toString(message));
        }
        this.t6_1.a5(this.s6_1);
        this.r6_1 = this.s6_1;
        this.s6_1 = -1;
      }
    }
    initMetadataForClass($, 'IteratorImpl');
    IteratorImplClass = $;
  }
  return IteratorImplClass;
}
var ListIteratorImplClass;
function ListIteratorImpl() {
  if (ListIteratorImplClass === VOID) {
    class $ extends IteratorImpl() {
      constructor($outer, index, $box) {
        if ($box === VOID)
          $box = {};
        $box.z6_1 = $outer;
        super($outer, $box);
        Companion_instance.a7(index, this.z6_1.q2());
        this.r6_1 = index;
      }
      b7() {
        return this.r6_1 > 0;
      }
      c7() {
        if (!this.b7())
          throw NoSuchElementException().u6();
        var tmp = this;
        this.r6_1 = this.r6_1 - 1 | 0;
        tmp.s6_1 = this.r6_1;
        return this.z6_1.r2(this.s6_1);
      }
    }
    initMetadataForClass($, 'ListIteratorImpl');
    ListIteratorImplClass = $;
  }
  return ListIteratorImplClass;
}
var SubListClass;
function SubList() {
  if (SubListClass === VOID) {
    class $ extends AbstractMutableList() {
      constructor(list, fromIndex, toIndex) {
        return new.target.h7(list, fromIndex, toIndex);
      }
      static h7(list, fromIndex, toIndex) {
        var $this = this.i7();
        $this.e7_1 = list;
        $this.f7_1 = fromIndex;
        $this.g7_1 = 0;
        Companion_instance.g6($this.f7_1, toIndex, $this.e7_1.q2());
        $this.g7_1 = toIndex - $this.f7_1 | 0;
        return $this;
      }
      z4(index, element) {
        Companion_instance.a7(index, this.g7_1);
        this.e7_1.z4(this.f7_1 + index | 0, element);
        this.g7_1 = this.g7_1 + 1 | 0;
      }
      r2(index) {
        Companion_instance.j7(index, this.g7_1);
        return this.e7_1.r2(this.f7_1 + index | 0);
      }
      a5(index) {
        Companion_instance.j7(index, this.g7_1);
        var result = this.e7_1.a5(this.f7_1 + index | 0);
        this.g7_1 = this.g7_1 - 1 | 0;
        return result;
      }
      j3(index, element) {
        Companion_instance.j7(index, this.g7_1);
        return this.e7_1.j3(this.f7_1 + index | 0, element);
      }
      k7(fromIndex, toIndex) {
        this.e7_1.k7(this.f7_1 + fromIndex | 0, this.f7_1 + toIndex | 0);
        this.g7_1 = this.g7_1 - (toIndex - fromIndex | 0) | 0;
      }
      q2() {
        return this.g7_1;
      }
      p6() {
        return this.e7_1.p6();
      }
    }
    initMetadataForClass($, 'SubList', VOID, VOID, [RandomAccess()]);
    SubListClass = $;
  }
  return SubListClass;
}
var AbstractMutableListClass;
function AbstractMutableList() {
  if (AbstractMutableListClass === VOID) {
    class $ extends AbstractMutableCollection() {
      static i7() {
        var $this = this.n6();
        $this.v6_1 = 0;
        return $this;
      }
      j2(element) {
        this.p6();
        this.z4(this.q2(), element);
        return true;
      }
      y4() {
        this.p6();
        this.k7(0, this.q2());
      }
      p1() {
        return new (IteratorImpl())(this);
      }
      t2(element) {
        return this.s4(element) >= 0;
      }
      s4(element) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlin.collections.indexOfFirst' call
          var index = 0;
          var _iterator__ex2g4s = this.p1();
          while (_iterator__ex2g4s.q1()) {
            var item = _iterator__ex2g4s.r1();
            if (equals(item, element)) {
              tmp$ret$0 = index;
              break $l$block;
            }
            index = index + 1 | 0;
          }
          tmp$ret$0 = -1;
        }
        return tmp$ret$0;
      }
      v2(index) {
        return new (ListIteratorImpl())(this, index);
      }
      b3(fromIndex, toIndex) {
        return SubList().h7(this, fromIndex, toIndex);
      }
      k7(fromIndex, toIndex) {
        var iterator = this.v2(fromIndex);
        // Inline function 'kotlin.repeat' call
        var times = toIndex - fromIndex | 0;
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            iterator.r1();
            iterator.q6();
          }
           while (inductionVariable < times);
      }
      equals(other) {
        if (other === this)
          return true;
        if (!(!(other == null) ? isInterface(other, KtList()) : false))
          return false;
        return Companion_instance.l7(this, other);
      }
      hashCode() {
        return Companion_instance.m7(this);
      }
    }
    initMetadataForClass($, 'AbstractMutableList', VOID, VOID, [KtMutableList()]);
    AbstractMutableListClass = $;
  }
  return AbstractMutableListClass;
}
//region block: exports
export {
  AbstractMutableList as AbstractMutableList192xfq8ycgofs,
};
//endregion

//# sourceMappingURL=AbstractMutableListJs.mjs.map
